<template>
    <div class="counterparty" v-if="items.length > 0">
        <legend>
            Маршрут
        </legend>
        <b-table striped  head-variant="dark" :thead-class="head_class"  class="table-responsive-xl resolution_table" :items="items" :fields="fields">
            <template  v-slot:cell(car)="data" >
                <div class="car_name" v-if="data.value.hasOwnProperty('title')">
                    {{data.value.title}}
                </div>
            </template>
        </b-table>
    </div>
</template>


<script>
export default {
    name: "mem_inside_trip",
    props : {
        "addon_data" : {
            type : Object
        },
        
        'mem' : {
            type : Object
        },
    },
    
    data() {
        return  {
            list_items : [],
            
            fields: [
                {
                    key: 'date_human_from',
                    label: 'Дата виїзду',
                    sortable: false
                },
                {
                    key: 'trip_from',
                    label: 'Звідки',
                    sortable: false
                },
                {
                    key: 'trip_to',
                    label: 'Куди',
                    sortable: false
                },
                {
                    key: 'car',
                    label: 'Машина',
                    sortable: false
                },
            ],
        }
    },
    
    computed : {
        items() {
            if(this.addon_data.hasOwnProperty('items')) {
                return this.addon_data.items;
            }
            return [];
        },
        
    },
}
</script>


<style scoped>

</style>